import AreaBarChart from './AreaBarChart'

const AreaCharts = () => {
    return <AreaBarChart />
}

export default AreaCharts
